/**
 * Route guards for the authenticated app surfaces.
 *
 * These read the SDK session directly (synchronously) so `beforeLoad` can redirect before any
 * page mounts — a `RunOnly` user must never see a half-rendered finalize screen, and a signed-out
 * deep link must land on the login page with a return path.
 */

import { redirect } from "@tanstack/react-router";
import { readAuthSession } from "@tensilelabs/auth-client";

export function requireSession(location: { href: string }): void {
  if (!readAuthSession()?.token) {
    throw redirect({ to: "/login", search: { redirect: location.href } });
  }
}

export function requireGuest(): void {
  if (readAuthSession()?.token) {
    throw redirect({ to: "/dashboard" });
  }
}
